import React from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import * as Actions from 'store/actions';

function ReusableLink({path, src, text, state}) {
  const baseColor = localStorage.getItem('companyColor') || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 90);

  return (
    <div className="flex items-center rounded-md gap-4 overflow-x-auto whitespace-nowrap">
      <NavLink
        end
        className={({isActive}) =>
          `rounded-md flex items-center w-full gap-2 pl-2 py-3 relative font-medium text-sm ${
            isActive ? 'text-brandBlue' : 'text-grey40'
          }`
        }
        style={({isActive}) => ({
          backgroundColor: isActive ? lighterShade : 'transparent',
        })}
        to={path}
        aria-current="page"
        state={state}
      >
        <img
          src={src}
          alt=""
          width={16}
          height={16}
          className="hidden md:block"
        />
        <span className="-mb-1">{text}</span>
      </NavLink>
    </div>
  );
}

export default connect(state => state, Actions)(ReusableLink);
